export default "__VITE_ASSET__3c7fe176__"